<template>
    <div class="p-5">
        <div v-if="cadhConfig.informations && cadhConfig.informations.length === 0
        && informations && informations.length === 0"
             class="text-center d-flex flex-column">
            <div>
                <button class="text-center cadh-add-button" @click="openCreateModal">
                    <span class="font-weight-bold h4">
                        + <br>
                        Ajouter une <br>
                        case à cocher
                    </span>
                </button>
            </div>

            <div class="mt-2">
                <a href="https://www.loom.com/share/69b8adacd1eb48b0878fa307abbabe76?t=0" target="_blank">
                    C'est quoi ?
                    <v-icon color="primary">open_in_new</v-icon>
                </a>
            </div>
        </div>

        <div v-else>
            <div class="d-flex justify-content-end mb-4">
                <v-btn class="text-none default-button mr-4" @click="openCreateModal">
                    <v-icon class="mr-1" color="white" dense>
                        add
                    </v-icon>
                    Ajouter une information
                </v-btn>

                <v-menu end transition="slide-y-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="text-none default-button" v-on="on" :disabled="!selectedInformations.length">
                            Sur la sélection
                            <v-icon>arrow_drop_down</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item @click="deleteMultipleInformations" :disabled="usedInCampaign">
                            <v-list-item-title>
                                <v-icon class="custom-button-error">delete</v-icon>
                                Supprimer les ({{ selectedInformations.length }}) options
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>

            <div>
                <filters></filters>
            </div>

            <v-simple-table class="mt-5">
                <thead>
                <tr>
                    <th class="text-left border-0" width="25px"></th>
                    <th class="text-left" width="40px">
                        <v-checkbox style="padding-top: 0 !important;"
                                    class="p-0 m-0"
                                    v-model="selectAll"
                                    @change="toggleSelectAll"
                                    hide-details>
                        </v-checkbox>
                    </th>
                    <th class="text-left">Nom</th>
                    <th class="text-left">Statut</th>
                    <th class="text-right">Actions</th>
                </tr>
                </thead>

                <draggable v-model="filteredInformations"
                           tag="tbody"
                           handle=".drag-handle"
                           :scroll-sensitivity="200"
                           :force-fallback="true"
                           :options="{
                                animation: 200,
                                ghostClass: 'sortable-ghost',
                                chosenClass: 'sortable-chosen'
                           }"
                           @start="setCopyInformations"
                           @end="onDragEnd"
                           @change="reorderInformations">
                    <tr v-for="information in filteredInformations">
                        <td class="border-0">
                            <v-icon class="drag-handle page__grab-icon" color="gray">mdi-drag</v-icon>
                        </td>
                        <td>
                            <v-checkbox style="padding-top: 0 !important;"
                                        class="p-0 m-0"
                                        v-model="information.selected"
                                        @change="updateSelectAllState"
                                        hide-details>
                            </v-checkbox>
                        </td>
                        <td>
                            <button @click="openUpdateModal(information)" class="text-primary text-start">
                                {{ information.name }}
                            </button>
                        </td>
                        <td>{{ information.enabled ? "Active" : "Masquée" }}</td>
                        <td class="text-right">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn small icon v-on="on" color="primary" class="custom-button-error"
                                           @click="openUpdateModal(information)">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </template>
                                <span>Modifier</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="ml-3 mr-3" small icon v-on="on"
                                           @click="duplicateInformation(information)">
                                        <v-icon>content_copy</v-icon>
                                    </v-btn>
                                </template>
                                <span>Dupliquer</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <button v-on="on" class="cadh-config-button-icon"
                                            @click="deleteInformation(information.id)"
                                            v-if="!usedInCampaign">
                                        <v-icon color="error">delete</v-icon>
                                    </button>
                                </template>
                                <span>Supprimer</span>
                            </v-tooltip>
                        </td>
                    </tr>
                </draggable>
            </v-simple-table>
        </div>

        <v-dialog ref="dialog" v-model="informationModal" width="900px" persistent>
            <create-information-modal
              :information="selectedInformation"
              :mode="modalMode"
            ></create-information-modal>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import Confirm from "../../tools/Confirm.vue"
import CreateInformationModal from "./CreateInformationModal.vue"
import Filters from "./Filters.vue"
import draggable from "vuedraggable"
import draggableMixin from "@/mixins/draggableMixin"

export default {
    name: "CadhConfigInformations",
    components: { Confirm, CreateInformationModal, Filters, draggable },
    mixins: [draggableMixin],
    data() {
        return {
            copyInformations: [],
            selectAll: false,
            selectedInformation: {},
            modalMode: null,
            filteredInformations: [],
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setInformationModal", "setModalCurrentStep", "setConfigInformations"]),
        openUpdateModal(information) {
            this.selectedInformation = JSON.parse(JSON.stringify(information))
            this.modalMode = "update"
            this.setModalCurrentStep("1")
            this.setInformationModal(true)
        },
        openCreateModal() {
            this.selectedInformation = {
                "name": "",
                "description": "",
                "order": this.cadhConfig.informations.length + 1,
                "enabled": true,
                "criterias": [],
            }
            this.modalMode = "create"
            this.setModalCurrentStep("1")
            this.setInformationModal(true)
        },
        deleteInformation(id) {
            this.$refs.confirm.open("Attention",
              "Voulez-vous vraiment supprimer cette information supplémentaire ?",
              { color: "red" }).then((confirm) => {
                if (confirm) {
                    this.$store.dispatch("cadhConfig/deleteInformation", id)
                }
            })
        },
        deleteMultipleInformations() {
            this.$refs.confirm.open("Attention",
              "Voulez-vous vraiment supprimer les informations supplémentaires sélectionnées ?",
              { color: "red" }).then((confirm) => {
                if (confirm) {

                    let payload = {
                        "ids": this.selectedInformations.map(option => option.id),
                    }

                    this.$store.dispatch("cadhConfig/deleteInformations", payload)
                }
            })
        },
        duplicateInformation(information) {
            this.selectedInformation = JSON.parse(JSON.stringify(information))
            this.selectedInformation.order = this.cadhConfig.informations.length + 1
            this.modalMode = "create"
            this.setModalCurrentStep("1")
            this.setInformationModal(true)
        },
        setCopyInformations(event) {
            this.copyInformations = JSON.parse(JSON.stringify(this.informations))

            this.onDragStart(event)
        },
        reorderInformations(event) {
            if (event.moved) {
                const pointerType = event.moved.newIndex !== this.informations.length - 1 ? "before" : "after"
                const moveObject = event.moved.element.id
                const pointerId = this.copyInformations[event.moved.newIndex].id

                this.$store.dispatch("cadhConfig/reorderList", [
                    "cadh_informations",
                    this.cadhConfig.id,
                    pointerId,
                    pointerType,
                    moveObject,
                ]).then(res => {
                    this.informations = res.body.data.items
                })
            }
        },
        updateSelectAllState() {
            const allSelected = this.informations.every(item => item.selected)
            this.selectAll = allSelected
        },
        toggleSelectAll() {
            this.filteredInformations.forEach(item => {
                item.selected = this.selectAll
            })
        },
        filerByQuestions() {
            return this.informations.filter(data => {
                return this.checkIfDataHasCriterias(data)
            })
        },
        checkIfDataHasCriterias(data) {
            let hasCriteria = false
            let criteriasIds = data.criterias.map(criteria => criteria.id)
            let newArray = []
            let resultsArray = []

            this.criteriaFamilies.forEach(family => {
                newArray[family.id] = family.criterias.filter(criteria => {
                    return this.criteriasFilter.includes(criteria.id)
                })
            })

            newArray.forEach(array => {
                if(array.length > 0) {
                    hasCriteria = array.map(obj => obj.id).some(value => criteriasIds.includes(value))
                    resultsArray.push(hasCriteria)
                }
            })

            return resultsArray.every((value) => value === true)
        },
        filterByName() {
            return this.informations.filter(type => {
                return type.name.toLowerCase().includes(this.searchName)
            })

        },
        filerByNameAndCriterias() {
            return this.informations.filter(type => {
                return type.name.toLowerCase().includes(this.searchName) && this.checkIfDataHasCriterias(type)
            })
        },
        setFilteredData(datas = null) {
            if (datas === null) {
                datas = this.informations
            }

            this.filteredInformations = datas
        },
        useRightFilter() {
            if ((this.searchName === "" || this.searchName === null) && this.criteriasFilter.length === 0) {
                this.setFilteredData()
            } else if ((this.searchName === "" || this.searchName === null) && this.criteriasFilter.length > 0) {
                this.setFilteredData(this.filerByQuestions())
            } else if (this.criteriasFilter.length === 0 && this.searchName !== "" && this.searchName !== null) {
                this.setFilteredData(this.filterByName())
            } else {
                this.setFilteredData(this.filerByNameAndCriterias())
            }
        },
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "informationModal", "configInformations", "searchName",
            "criteriasFilter", "usedInCampaign", "criteriaFamilies"]),
        informations: {
            get() {
                return this.configInformations
            },
            set(value) {
                this.$store.commit("cadhConfig/setConfigInformations", value)
            },
        },
        selectedInformations() {
            return this.filteredInformations.filter(information => information.selected)
        },
    },
    watch: {
        searchName() {
            this.useRightFilter()
        },
        criteriasFilter() {
            this.useRightFilter()
        },
        informations() {
            if ((this.searchName === "" || this.searchName === null) && this.criteriasFilter.length === 0) {
                this.filteredInformations = this.informations
            } else if ((this.searchName === "" || this.searchName === null) && this.criteriasFilter.length > 0) {
                this.filteredInformations = this.filerByQuestions()
            } else if (this.criteriasFilter.length === 0 && this.searchName !== "" && this.searchName !== null) {
                this.filteredInformations = this.filterByName()
            } else {
                this.filteredInformations = this.filerByNameAndCriterias()
            }
        },
    },
}
</script>